import React, { Component } from 'react';
import RevenueManagementContainer from '../components/RevenueManagement/RevenueManagementContainer';
import RevenueManagementTabs from '../components/RevenueManagement/RevenueManagementTabs';
import { Row, Col, Container } from 'reactstrap';
import { Link } from 'react-router-dom';

class RevenueManagement extends Component {

    constructor(props) {
        super(props);
        this.listView = this.props.location.pathname.split('/').filter(item => item !== '').pop() === 'revenue-management' ? true : false;
        this.clientId = !this.listView ? this.props.location.pathname.split('/').filter(item => item !== '').pop() : 0;

        this.state = {
            revenueManagement: {
                customerNumber: '',
                name: '',
                services: null
            },
        };
    }

    componentDidMount = () => {
        this.props.log('RevenueManagement.js/componentDidMount');
        this.getRevenueManagement();
    }

    getRevenueManagement = () => {
        this.props.log('RevenueManagement.js/getEmployees');
        fetch('/api/revenue-management/' + this.clientId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        revenueManagement: results.data[0]
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render = () => {
        this.props.info('RevenueManagement.js/render');
        return (
            this.listView && this.state.revenueManagement.name === '' ? <RevenueManagementContainer  {...this.props} /> :
                <Container fluid>
                    {this.state.revenueManagement.services != null && <>
                    <Row>
                        <Col>
                            <h2>{this.state.revenueManagement.name} ({this.state.revenueManagement.customerNumber})</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="text-left p-4">
                            <Link to={{ pathname: '/revenue-management/' }}>Back to Clients List</Link>
                        </Col>
                    </Row>
                    <RevenueManagementTabs {...this.props} clientId={this.clientId} services={this.state.revenueManagement.services} />
                    </>}
                </Container>
        );
    }
}

export default RevenueManagement;
